// API key (ensure you secure this key in production)
const API_KEY = '2a5b6c7d-2e4f-4321-b8c9-0a1b2c3d4e5f';
const BASE_URL = 'https://pos.jonipay.net';

export {BASE_URL, API_KEY};
